import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { LoadingScreenService } from '../../services/loading-screen/loading-screen.service';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-loading-screen',
    imports: [
        NgClass
    ],
    templateUrl: './loading-screen.component.html',
    styleUrls: ['./loading-screen.component.scss']
})
export class LoadingScreenComponent {
  loadingSubscription: Subscription = new Subscription();

  constructor(
    public loadingScreenService: LoadingScreenService
  ) { }

}
